import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../../core'
import * as goal from '../../goal'

export const RESOURCE = {
  payload: {
    modelId: goal.MODEL_ID,
    values: {
      // TODO: get multi-range to work
      // 'active_periods': new AtnMultirange<Date>(),
      [PartialId.Standard.create('active_periods')]: '{[1-1-2023,12-31-2024]}',
      [PartialId.Standard.create('code')]: '1.1.3',
      [PartialId.Standard.create('descr')]:
        'Expand the portfolio of experiential learning opportunities, including internships, entrepreneurship, service learning, community engagement, study abroad, and research opportunities, for students to apply their skills and competencies in and beyond the classroom.',
      [PartialId.Standard.create('id')]: 'gmu_1_1_3',
      [PartialId.Standard.create('name')]:
        'Experiential learning opportunities',
    },
  },
  type: core.quiver.Resource.Type.DmsRecord,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsRecord>
